import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "overflow-x-auto" }
const _hoisted_2 = {
  key: 0,
  class: "w-full table-auto"
}
const _hoisted_3 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_4 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_5 = {
  scope: "col",
  class: "py-2 capitalize"
}
const _hoisted_6 = {
  scope: "col",
  class: "py-2 capitalize"
}
const _hoisted_7 = { class: "px-2 py-3 capitalize" }
const _hoisted_8 = { class: "py-3" }
const _hoisted_9 = {
  key: 0,
  class: "text-sm capitalize"
}
const _hoisted_10 = {
  key: 1,
  class: "text-sm capitalize"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 2,
  class: "text-sm text-red-500 capitalize"
}
const _hoisted_13 = { class: "py-3" }
const _hoisted_14 = ["href"]
const _hoisted_15 = ["href"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "py-8 text-center" }

import { PropType, ref } from "vue";

import RoleGuard from "@/components/RoleGuard.vue";

import api from "@/api/api";
import { User } from "@/types";
import { useUserStore } from "@/store";
import { getCertificateUrl, shouldShowCertificateUrl } from "@/utils/certificates";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserCourses',
  props: {
  user: {
    type: Object as PropType<User>,
    required: true,
  },
},
  async setup(__props) {

let __temp: any, __restore: any

const props = __props;

const { user: currentUser } = useUserStore();



const courses = ref();
courses.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.users.getCoursesByUser(props.user.id, "created_at", "desc"))),
  __temp = await __temp,
  __restore(),
  __temp
)).data;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (courses.value.courses.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_3, [
              _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t("course-details")), 1),
              _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t("status")), 1),
              _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("actions")), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courses.value.courses, (course) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "border-b border-gray-400 even:bg-gray-200 whitespace-nowrap",
                key: course.id
              }, [
                _createElementVNode("td", _hoisted_7, [
                  _createVNode(_component_router_link, {
                    to: `/dashboard/courses/events/${course.event?.id}`,
                    class: "capitalize text-blue"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(course.event?.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("td", _hoisted_8, [
                  _createElementVNode("div", null, [
                    (course.user_attended && !course.user_removed)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Complete " + _toDisplayString(new Date(course.completed_at).toLocaleDateString()), 1))
                      : _createCommentVNode("", true),
                    (!course.user_attended && !course.user_removed)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                          (course.event.template.moodle_course_id)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(course.completed_amount) + "%", 1))
                            : _createCommentVNode("", true),
                          _createTextVNode(" (" + _toDisplayString(_ctx.$t("in-progress")) + ") ", 1)
                        ]))
                      : _createCommentVNode("", true),
                    (!course.user_attended && course.user_removed)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "(" + _toDisplayString(_ctx.$t("removed")) + ")", 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", _hoisted_13, [
                  _createVNode(RoleGuard, { roles: ['admin', 'courses-admin', 'users-admin', 'clubs-admin'] }, {
                    default: _withCtx(() => [
                      (!course.user_removed)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/dashboard/courses/events/${course.event.id}/bookings/${course.id}`,
                            class: "text-blue"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("View")
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      (_unref(shouldShowCertificateUrl)(course))
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: _unref(getCertificateUrl)(course, __props.user),
                            class: "block mt-1 text-blue"
                          }, _toDisplayString(_ctx.$t("view-certificate")), 9, _hoisted_14))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024),
                  (course.event.organisation_id === _unref(currentUser).organisation_id)
                    ? (_openBlock(), _createBlock(RoleGuard, {
                        key: 0,
                        roles: ['trainer-organisation', 'l4a-trainer']
                      }, {
                        default: _withCtx(() => [
                          (!course.user_removed)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: `/dashboard/courses/events/${course.event.id}/bookings/${course.id}`,
                                class: "text-blue"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("View")
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true),
                          (course.user_attended && course.payment_method !== 'Migration')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: _unref(getCertificateUrl)(course, __props.user),
                                class: "block mt-1 text-blue"
                              }, _toDisplayString(_ctx.$t("view-certificate")), 9, _hoisted_15))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  (course.event.organisation_id === _unref(currentUser).organisation_id)
                    ? (_openBlock(), _createBlock(RoleGuard, {
                        key: 1,
                        roles: ['facilitator-organisation']
                      }, {
                        default: _withCtx(() => [
                          (!course.user_removed)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: `/dashboard/courses/events/${course.event.id}`,
                                class: "text-blue"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("View")
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("this-user-has-no-events")), 1)
        ]))
  ]))
}
}

})